// extracted by mini-css-extract-plugin
export default {"container":"Kp-z","ratingLayout":"Lp-z","ratingLabel":"Mp-z","nonInteractiveRatingLabel":"Np-z"};